import React from "react";
import Select from "react-select";

import moment from "moment";

import { ButtonGroup, Button, Icon } from "aible";

import { OverlayTrigger, Popover } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import { LineInput } from "components/Inputs/LineInput";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import DatasetItemContainer from "containers/View/Item/DatasetItem";
import OptimizerTile from "components/Tiles/OptimizerTile";

import empty2 from "images/soda/empty-2.jpg";
import full1 from "images/soda/full-1.jpg";
import full2 from "images/soda/full-2.jpg";
import partial1 from "images/soda/partial-1.jpg";
import partial3 from "images/soda/partial-4.jpg";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class AdvancedModels extends React.Component {
  constructor(props) {
    super(props);

    // article
    const articleFields = [
      {
        label: "Resource Title",
        sType: "Text Analytics",
        uType: "Generate Helper AI Field",
        uOption: "Pre-Built",
        confidence: 0.52
      },
      {
        label: "Resource Text",
        sType: "Sentiment Analysis",
        uType: "Standalone AI",
        uOption: "Pre-Built",
        confidence: 0.32
      },
      {
        label: "Resource Summary",
        sType: "Sentiment Analysis",
        uType: "Standalone AI",
        uOption: "Pre-Built",
        confidence: 0.32
      }
    ];

    // stockout
    const imageFields = [
      {
        label: "Picture",
        sType: "Image Classification",
        uType: "Both",
        uOption: "Pre-Built",
        confidence: 0.87
      },
      {
        label: "Notes",
        sType: "Text Analytics",
        uType: "Both",
        uOption: "Pre-Built",
        confidence: 0.42
      }
    ];

    const fields = [
      {
        label: "Resource Title",
        sType: "Text Analytics",
        uType: "Generate Helper AI Field",
        uOption: "Pre-Built",
        confidence: 0.52
      },
      {
        label: "Resource Text",
        sType: "Sentiment Analysis",
        uType: "Standalone AI",
        uOption: "Pre-Built",
        confidence: 0.32
      },
      {
        label: "Resource Summary",
        sType: "Sentiment Analysis",
        uType: "Standalone AI",
        uOption: "Pre-Built",
        confidence: 0.32
      },
      {
        label: "Picture",
        sType: "Image Classification",
        uType: "Both",
        uOption: "Pre-Built",
        confidence: 0.87
      },
      {
        label: "Notes",
        sType: "Text Analytics",
        uType: "Both",
        uOption: "Pre-Built",
        confidence: 0.42
      }
    ];

    this.state = {
      isTraining: false,
      hasTrained: false,
      fields:
        props && props.dataset && props.dataset.label
          ? props.dataset.label.toLowerCase().indexOf("article") !== -1
            ? articleFields
            : props.dataset.label.toLowerCase().indexOf("resource") !== -1
              ? imageFields
              : fields
          : fields,
      isOpen: false,
      images: [empty2, full1, partial1, full2, partial3],
      image: empty2,
      processed: 0
    };
  }

  renderBefore() {
    const { dataset, fields, addField, updateField, isNext } = this.props;
    const { isTraining } = this.state;

    const specialOptions = [
      { label: "Text Analytics", value: "document" },
      { label: "Sentiment Analysis", value: "sentiment" },
      { label: "Translate To: English", value: "translate" },
      { label: "Image Classification", value: "image" },
      { label: "Transcribe Audio", value: "speech_audio" },
      { label: "OCR", value: "image_text" }
    ];

    const datasetFieldLabels = Object.keys(dataset.fields).map((field) => ({
      label: field,
      value: field
    }));

    const nonManualFields = fields.filter((f) => !f.isManual).length;

    const colStyle = isNext ? styles.tColNext : styles.tCol;

    return (
      <div className={styles.advancedModels}>
        <div className={styles.title}>{`Additional AI Options${nonManualFields ? " Detected" : ""}`}</div>
        <div className={styles.subTitle} style={{ marginTop: "5px" }}>
          {(nonManualFields
            ? `Aible found ${nonManualFields} column${
                nonManualFields > 1 ? "s" : ""
              } that would benefit from additional AI analysis`
            : "") + ". Select the columns you would like to apply the specialized AI analysis to."}
        </div>
        <div className={styles.optionHolder} style={{ marginTop: "20px" }}>
          <div className={styles.tHeader}>
            <div className={colStyle}>{"Include"}</div>
            <div className={colStyle}>{"Field"}</div>
            <div className={colStyle}>{"Specialized AI Type"}</div>
            <div className={colStyle}>{""}</div>
            <div className={colStyle}>{""}</div>
          </div>
          {fields.map((f, i) => (
            <div className={styles.tRow} key={f.id}>
              <div className={colStyle}>
                <Button
                  active={f.uOption !== "Skip"}
                  onClick={() => updateField(f.id, { uOption: f.uOption !== "Skip" ? "Skip" : "Create Helper AI" })}
                >
                  {f.uOption === "Skip" ? "Include as Helper AI" : "Included as Helper AI"}
                </Button>
              </div>
              <div className={colStyle}>
                {!f.isManual && f.label !== undefined ? (
                  f.label
                ) : (
                  <Select
                    options={datasetFieldLabels}
                    onChange={(val) => {
                      updateField(f.id, { label: val.value });
                    }}
                  />
                )}
              </div>
              <div className={colStyle}>
                <Select
                  options={specialOptions}
                  value={specialOptions.find((o) => o.value == f.sType)}
                  onChange={(val) => {
                    updateField(f.id, { sType: val.value });
                  }}
                />
              </div>
              <div className={colStyle}>
                <ButtonGroup>
                  {f.isManual && <Button onClick={() => updateField(f.id, { deleted: true })}>Remove</Button>}
                </ButtonGroup>
              </div>
              {f.probability !== undefined && (
                <div>
                  {"Confidence"}
                  <div className={styles.confidence} style={{ width: "150px" }}>
                    <div className={styles.filledConfidence} style={{ width: f.probability * 100 + "%" }} />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className={styles.buttonHolder} style={{ paddingLeft: "8px", paddingBottom: "2px" }}>
          <Button
            disabled={isTraining}
            onClick={() =>
              addField({
                isManual: true,
                uOption: "Pre-Built"
              })
            }
            style={{ height: "38px", position: "relative" }}
          >
            <FontAwesomeIcon icon={faPlus} />
            <span style={{ marginLeft: "5px", display: "none" }}>{"Manually Add Field"}</span>
          </Button>
        </div>
      </div>
    );
  }

  renderAfter() {
    const options = [
      {
        label: "Imputation Results",
        type: "Imputation",
        columns: ["State", "Churned", "Days Since Contact"],
        confidence: [0.45, 0.78, 0.21],
        missing: [45, 198, 102]
      },
      {
        label: "Sentiment Results",
        type: "Sentiment",
        columns: ["Chat-Transcript", "Emails"],
        confidence: [0.41, 0.31]
      },
      {
        label: "Image Classification Results",
        type: "Image Classification",
        columns: ["Img-Attachment"],
        confidence: [0.86]
      }
    ];

    return (
      <div className={styles.advancedModels}>
        <div className={styles.title}>{"Additional AI Analysis Results"}</div>
        <div className={styles.subTitle} style={{ marginTop: "5px" }}>
          {"Here is the results from the analysis and the confidence " +
            "that Aible has in the ability to predict the " +
            "content in these columns. Select the new data you would like to include."}
        </div>
        <div className={styles.optionHolderAfter} style={{ marginTop: "20px" }}>
          {options.map((option) => (
            <div className={styles.option}>
              <div className={styles.bold}>{option.label}</div>
              {option.columns.map((c, i) => (
                <div className={styles.rOption}>
                  <div className={styles.resultTitle}>
                    <div style={{ width: "150px" }}>
                      {"COLUMN" + (option.type === "Imputation" ? "(TOTAL MISSING)" : "")}
                    </div>
                    <div style={{ width: "150px" }}>{option.type + " CONFIDENCE"}</div>
                  </div>
                  <div className={styles.flex}>
                    <div className={styles.resultOption} style={{ width: "150px" }}>
                      <input type="checkbox" checked />
                      <div
                        style={{
                          marginLeft: "5px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }}
                        title={c + (option.type === "Imputation" ? " (" + option.missing[i] : ")")}
                      >
                        {c + (option.type === "Imputation" ? " (" + option.missing[i] : ")")}
                      </div>
                    </div>
                    <div className={styles.confidence} style={{ width: "150px" }}>
                      <div className={styles.filledConfidence} style={{ width: option.confidence[i] * 100 + "%" }} />
                    </div>
                  </div>
                  <a>{"Review Results"}</a>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderModal() {
    const {
      isImageOpen,
      dataset,
      combinedDatasetId,
      combinedProject,
      updateIsImageOpen,
      updateModelOutcomeColumn,
      setupAI
    } = this.props;
    const { isTag, isColumn, openField } = this.state;

    return (
      <Dialog show={isImageOpen} onHide={() => updateIsImageOpen(false)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{"Train AI"}</DialogTitle>
          </DialogHeader>
          {combinedDatasetId !== undefined ? (
            <div className={styles.body}>
              <div className={styles.mQuestion}>
                <div className={styles.title}>{"Importing and Training Image Classification Model"}</div>
              </div>
              {<DatasetItemContainer id={combinedDatasetId} />}
              {combinedProject !== undefined && <OptimizerTile data={combinedProject} />}
            </div>
          ) : (
            <div className={styles.body}>
              <div className={styles.mQuestion}>
                <div className={styles.title}>{"What are you trying to identify in the images?"}</div>
                <ButtonGroup>
                  <Button active={isTag !== true} onClick={() => this.setState({ isTag: false })}>
                    {"Classify an Image"}
                  </Button>
                  <Button active={isTag === true} onClick={() => this.setState({ isTag: true })}>
                    {"Tag an Image"}
                  </Button>
                </ButtonGroup>
              </div>
              <div className={styles.mQuestion}>
                <div className={styles.title}>{"Is there a column in your data that contains the categorization?"}</div>
                <ButtonGroup>
                  <Button active={isColumn === true} onClick={() => this.setState({ isColumn: true })}>
                    {"Yes"}
                  </Button>
                  <Button active={isColumn !== true} onClick={() => this.setState({ isColumn: false })}>
                    {"No"}
                  </Button>
                </ButtonGroup>
              </div>
              {isColumn === true ? (
                <div>
                  <div className={styles.title}>{"Select the column that contains the categorization"}</div>
                  <div style={{ width: "400px" }}>
                    <Select
                      options={
                        dataset && dataset.fields
                          ? Object.keys(dataset.fields).map((f) => ({
                              label: f,
                              value: f
                            }))
                          : []
                      }
                      placeholder="Select a Column"
                      onChange={(val) => updateModelOutcomeColumn(val.value)}
                    />
                  </div>
                  <Button
                    type="primary"
                    style={{ marginTop: "20px" }}
                    onClick={() => {
                      const oFields = this.state.fields.map((f) =>
                        f.label === openField ? { ...f, isTrained: true } : { ...f }
                      );
                      setupAI();
                      updateIsImageOpen(false);
                      this.setState({ fields: oFields });
                    }}
                  >
                    {"Setup AI Training"}
                  </Button>
                </div>
              ) : (
                <div>{this.renderTraining()}</div>
              )}
            </div>
          )}
          <DialogFooter>
            <Button type="secondary" onClick={() => updateIsImageOpen(false)}>
              {"Close"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }

  setRandomImage(isAdv) {
    const { images } = this.state;

    this.setState({
      image: images[(this.state.processed + 1) % images.length],
      isClassified: undefined,
      processed: isAdv ? this.state.processed + 1 : this.state.processed - 1,
      tags: undefined
    });
  }

  renderTraining(image) {
    const { iName, isTag, fields, openField, tags } = this.state;

    const { buildAI, classifiers, datasetHeaders, datasetRows, updateClassifiers, updateClassifierName } = this.props;

    console.log(this.props);
    console.log(datasetHeaders);

    datasetHeaders && datasetHeaders[0] && console.log(datasetHeaders[0].split(","));

    const imgColumn = 50;

    console.log("col index");
    console.log(imgColumn);

    console.log(classifiers);

    let nextImage = classifiers ? classifiers.indexOf("") : -1;

    console.log(nextImage);

    const imgUrl =
      nextImage !== undefined && datasetRows && datasetRows[nextImage]
        ? datasetRows[nextImage].split(",")[imgColumn]
        : undefined;

    console.log(imgUrl);

    const processed = classifiers ? classifiers.filter((c) => c !== "").length / (classifiers.length - 1) : 0;

    return isTag ? (
      <div>
        <div className={styles.title}>{"Add Image Tags"}</div>
        <div className={styles.aFlex}>
          <div className={styles.feedbackWrapper}>
            <div className={styles.feedbackSection}>
              <div className={styles.feedbackTitle}>{"Tags"}</div>
              <div className={styles.feedbackTagsWrapper}>
                {tags &&
                  tags.map((tag, i) => (
                    <TagItem
                      key={"tag " + (tag ? tag.name : i)}
                      tag={tag}
                      handleDelete={() => console.log("delete")}
                      isCreator={true}
                      style={{ marginBottom: "6px" }}
                    />
                  ))}
              </div>
              <AddTag
                addTag={(e) =>
                  this.setState({
                    tags: tags ? [...this.state.tags, { name: e }] : [{ name: e }]
                  })
                }
              />
            </div>
          </div>
          <div
            style={{
              marginLeft: "10px",
              marginTop: tags && tags.length > 0 ? "10px" : "-20px",
              display: "flex",
              alignItems: "center"
            }}
          >
            <Button style={{ marginLeft: "10px" }} onClick={() => this.setRandomImage()}>
              {"Previous Image"}
            </Button>
            <Button style={{ marginLeft: "10px" }} onClick={() => this.setRandomImage(true)}>
              {"Next Image"}
            </Button>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start"
          }}
        >
          <img src={imgUrl} className={styles.image} />
        </div>
        <div style={{ marginTop: "20px" }}>
          {"Data Needed for AI Training: " + Math.round(processed * 100) + "%"}
          <div className={styles.confidence} style={{ width: "500px" }}>
            <div className={styles.filledConfidence} style={{ width: processed * 100 + "%" }} />
          </div>
        </div>
        <Button
          type="primary"
          style={{ marginTop: "20px" }}
          onClick={() => {
            const oFields = fields.map((f) => (f.label === openField ? { ...f, isTrained: true } : { ...f }));
            this.setState({ isOpen: false, fields: oFields });
          }}
        >
          {"Train AI"}
        </Button>
      </div>
    ) : (
      <div>
        <div className={styles.title}>{"I want to identify"}</div>
        <div className={styles.aFlex}>
          <div style={{ width: "500px" }}>
            <LineInput
              isMediumBox
              placeholder="Choose a name for the image"
              onChange={(val) => updateClassifierName(val)}
            />
          </div>
          <Button style={{ marginLeft: "10px" }} onClick={() => this.setRandomImage()} disabled>
            {"Previous Image"}
          </Button>
          <Button style={{ marginLeft: "10px" }} onClick={() => this.setRandomImage(true)} disabled>
            {"Next Image"}
          </Button>
        </div>
        <div style={{ marginTop: "10px" }}>
          {"Does this image contain " + (iName === undefined ? " the classifcation" : iName)}
        </div>
        <ButtonGroup>
          <Button
            onClick={() => {
              datasetRows
                .filter((r, i) => i >= nextImage)
                .forEach((r, i) => {
                  if (r.split(",")[imgColumn] === imgUrl) {
                    classifiers[nextImage + i] = "Yes";
                  }
                });
              updateClassifiers(classifiers);
            }}
            active={this.state.isClassified === true}
          >
            {"Yes"}
          </Button>
          <Button
            onClick={() => {
              datasetRows
                .filter((r, i) => i >= nextImage)
                .forEach((r, i) => {
                  if (r.split(",")[imgColumn] === imgUrl) {
                    classifiers[nextImage + i] = "No";
                  }
                });
              updateClassifiers(classifiers);
            }}
          >
            {"No"}
          </Button>
        </ButtonGroup>
        <img src={imgUrl} className={styles.image} />
        <div style={{ marginTop: "20px" }}>
          {"Data Needed for AI Training: " + Math.round(processed * 100) + "%"}
          <div className={styles.confidence} style={{ width: "500px" }}>
            <div className={styles.filledConfidence} style={{ width: processed * 100 + "%" }} />
          </div>
        </div>
        {this.state.isBuilding ? (
          <LoadingIndicator style={{ margin: "0px" }} />
        ) : (
          <Button
            type="primary"
            style={{ marginTop: "20px" }}
            onClick={() => {
              this.setState({ isBuilding: true });
              buildAI();
            }}
          >
            {"Setup AI Training"}
          </Button>
        )}
      </div>
    );
  }

  render() {
    const { fields } = this.props;
    const { hasTrained } = this.state;

    return fields === undefined ? (
      <div>{"No specialized AI fields found in this dataset."}</div>
    ) : (
      <div>
        {this.renderModal()}
        {hasTrained === true ? this.renderAfter() : this.renderBefore()}
      </div>
    );
  }
}

class TagItem extends React.PureComponent {
  render() {
    const { isCreator, noClick, handleDelete, tag, noOverlay, className, ...retProps } = this.props;
    return (
      <OverlayTrigger
        placement="top"
        trigger={noClick || noOverlay ? [] : ["click"]}
        rootClose
        overlay={
          <Popover id="popover-positioned-top" title={tag && tag.name}>
            <div className={styles.commentItemWrapper} style={{ marginBottom: "0px" }}>
              {/* <div className={styles.commentMessage}>{tag && tag.name}</div> */}
              <div className={styles.commentAuthor}>{tag && tag.created_by ? tag.created_by.fullname : ""}</div>
              <div className={styles.commentTime}>
                {moment
                  .utc(tag && tag.updated_date)
                  .local()
                  .format("MMMM Do YYYY, h:mm:ss a")}
              </div>
              <div className={styles.tagActions}>{isCreator ? <a onClick={handleDelete}>Delete</a> : ""}</div>
            </div>
          </Popover>
        }
      >
        <div
          className={styles.tagItemWrapper + " " + (noClick ? styles.noClick : "") + " " + (className ? className : "")}
          {...retProps}
        >
          {tag && tag.name}
        </div>
      </OverlayTrigger>
    );
  }
}

class AddTag extends React.Component {
  state = { isEdit: true, tagName: "" };
  handleClose() {
    this.setState({ isEdit: true, tagName: "" });
  }
  handleOpen() {
    this.setState({ isEdit: true });
  }
  render() {
    const { addTag } = this.props;
    const { isEdit, tagName } = this.state;
    return (
      <div className={styles.addTagWrapper}>
        <div className={styles.addCommentLink}>
          <Icon type={"tagPurple"} size={13} />
          <a onClick={() => (isEdit ? this.handleClose() : this.handleOpen())}>{"Add Tag"}</a>
        </div>
        <div className={styles.addTagEdit + " " + (!isEdit ? styles.hide : "")}>
          <textarea
            className={styles.addCommentInput}
            placeholder={"Enter Tag Name"}
            value={tagName}
            onChange={(e) => this.setState({ tagName: e.target.value })}
            rows={1}
          />
          <div className={styles.addCommentButtons}>
            <Button type={"secondary"} onClick={() => this.handleClose()}>
              {"Cancel"}
            </Button>
            <Button
              style={{ marginLeft: "auto" }}
              type={"primary"}
              onClick={() => {
                return addTag(tagName);
              }}
            >
              {"Add Tag"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
